// src/utils/formatDateTime.js
export const formatDateTime = (datetime) => {
  return datetime
    ? new Date(datetime).toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "-";
};
